var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsuarios(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#98CBC2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;stroke:#98CBC2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 45.1,
    cy: 23.1,
    r: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.8,45.8c0-7.8,6.3-14.1,14.1-14.1S58.9,38,58.9,45.8"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 19.6,
    cy: 23.1,
    r: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.3,45.8c0-7.8,6.3-14.1,14.1-14.1s14.1,6.3,14.1,14.1"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 32.2,
    cy: 29.3,
    r: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.9,51.9c0-7.8,6.3-14.1,14.1-14.1s14.1,6.3,14.1,14.1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsuarios);
export default __webpack_public_path__ + "static/media/usuarios.39bd77863113982d1ad969069623f17b.svg";
export { ForwardRef as ReactComponent };